import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function getMyStaffRoles(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyStaffRole${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSharedStaffRoles() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedStaffRole`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllStaffRoleByReportingUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllStaffRoleByReportingUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
} async function getByAddStaffRoleId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByAddStaffRoleId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteAddStaffRole(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteAddStaffRole/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createAddStaffRole(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAddStaffRole`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateAddStaffRole(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAddStaffRole/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createAddStaffRole,
    updateAddStaffRole,
    deleteAddStaffRole,
    getSharedStaffRoles,
    getMyStaffRoles,
    findAllStaffRoleByReportingUser,
    getByAddStaffRoleId,
}